var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.46664V1H37.7097V9.46664C36.7306 9.78214 35.8845 10.3606 35.2871 11.1229C34.6898 11.8852 34.3704 12.7941 34.3728 13.725C34.3704 14.6559 34.6898 15.5648 35.2871 16.3271C35.8845 17.0894 36.7306 17.6679 37.7097 17.9834V26.45H1V17.9834C1.97908 17.6679 2.82522 17.0894 3.42257 16.3271C4.01992 15.5648 4.33927 14.6559 4.33691 13.725C4.33927 12.7941 4.01992 11.8852 3.42257 11.1229C2.82522 10.3606 1.97908 9.78214 1 9.46664Z",
    stroke: "#FF7B9A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7693 6.74609L19.358 10.8509L23.9467 6.74609M13.8516 11.6719H24.8645M13.8516 16.7348H24.8645M19.358 11.6719V21.5235",
    stroke: "#FF7B9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponicon);
export default __webpack_public_path__ + "static/media/couponicon.9f3b18aa2c3595377865b67359d4aab6.svg";
export { ForwardRef as ReactComponent };